const subjectCategoryToCodeMap = {
  Arabic: 'ARABIC',
  Art: 'ART',
  Biology: 'BIOLOGY',
  English: 'ENGLISH',
  ICT: 'ICT',
  'Islamic Studies': 'ISLAMIC_STUDIES',
  Math: 'MATH',
  Music: 'MUSIC',
  PE: 'PE',
  Physics: 'PHYSICS',
  Science: 'SCIENCE',
  'Social Studies': 'SOCIAL_STUDIES',
  'Alef Stars': 'ALEF_STARS',
  Default: 'DEFAULT',
};

const getCodeFromSubjectCategory = subjectCategory =>
  subjectCategoryToCodeMap[subjectCategory];

export { getCodeFromSubjectCategory };
